import BigNumber from "bignumber.js";

/**
 * Thin wrappers over `bignumber.js` rounding, so call sites deal in plain `number`s and a
 * single rounding mode (`ROUND_HALF_UP`) instead of the library's `.dp()`/rounding-mode API.
 */
export const BigNumberExt = {
	/**
	 * Rounds a `BigNumber` to `precision` decimal places (`ROUND_HALF_UP` — half-up, not
	 * ceiling) and unwraps it to a plain `number`.
	 */
	roundUp(value: BigNumber, precision: number): number {
		return value.dp(precision, BigNumber.ROUND_HALF_UP).toNumber();
	},
	/**
	 * Rounds `value` to `precision` decimal places (`ROUND_HALF_UP`), snapping it onto a chosen
	 * decimal grid. Non-finite values pass through unchanged.
	 */
	roundWithPrecision(value: number, precision: number): number {
		if (!Number.isFinite(value)) {
			return value;
		}
		return BigNumberExt.roundUp(BigNumber(value), precision);
	},
};
